// import { RequestService } from '../../../../../common/services/RequestService';
// import { GET_ALL_ORDERS } from '../constants';
// import { dataAdjustmentResponse } from '../orders/dataAdjustment';

import HARDCODE_History from '../../../common/hardCodeData/crm'; // todo подключить АПИ

export const getAllMailHistoryRequest = async profileId => {
  return HARDCODE_History;
  /*
  const response = await RequestService.get(
    GET_ALL_ORDERS.replace('{profile_id}', profileId)
  );
  return (
    response.data &&
    Array.isArray(response.data) &&
    response.data.map(order => dataAdjustmentResponse(order))
  );
  */
};
